// extracted by mini-css-extract-plugin
export default {"tooltip":"SelectProfileTooltip_tooltip__K-Cyz","tooltipBold":"SelectProfileTooltip_tooltipBold__KoYvf","label":"SelectProfileTooltip_label__CUxEM"};